export default {
  state: () => ({
    data: {
      currentCityId: null,
      defaultCityId: 2182, // Kyiv by default (city ID in New Post list). According Technical Task - Kyiv is a default city.
    },
  }),
  mutations: {
    'stores/setState'(state, payload) {
      state.data = {
        ...payload,
        currentCityId: state.data.currentCityId,
        defaultCityId: state.data.defaultCityId,
      };
    },
    'stores/changeCurrentCityId'(state, payload) {
      state.data = { ...state.data, currentCityId: payload };
    },
  },
  actions: {},
  getters: {
    'stores/getCurrentCityId': ({ data: { currentCityId } }, rootGetters) =>
      currentCityId ?? rootGetters['cities/id'],
    'stores/getActiveCityName': ({ data: { cities, defaultCityId } }, getters) =>
      cities?.find((el) => el.ID == getters['stores/getCurrentCityId'])?.UF_NAME ??
      cities?.find((el) => el.ID == defaultCityId)?.UF_NAME,
    'stores/getActiveCity': ({ data: { cities, defaultCityId } }, getters) =>
      cities?.find((el) => el.ID == getters['stores/getCurrentCityId']) ??
      cities?.find((el) => el.ID == defaultCityId),
    'stores/getStoresFilteredByCity': ({ data: { stores, defaultCityId } }, getters) => {
      let filteredStores = stores?.filter((el) => el.cityId == getters['stores/getCurrentCityId']);
      /**
       * if there are no matches for the current city, need to select warehouses for the default city ( According Technical Task )
       */
      if (filteredStores?.length == 0) {
        filteredStores = stores?.filter((el) => el.cityId == defaultCityId);
      }
      return filteredStores;
    },
    // ['stores/getStoresFilteredByCityAndAmount']: ({ data: { stores, defaultCityId } }, getters) => {
    //     let filteredStores = stores?.filter(el => el.cityId == getters['stores/getCurrentCityId'] && el.amount > 0);
    //     /**
    //      * if there are no matches for the current city, need to select warehouses for the default city ( According Technical Task )
    //      */
    //     if (filteredStores?.length == 0) {
    //         filteredStores = stores?.filter(el => el.cityId == defaultCityId && el.amount > 0);
    //     }
    //     return filteredStores;
    // },
    'stores/getStoresFilteredByCityAndAmount': ({ data: { stores, defaultCityId } }, getters) => {
      /** at first let filter by product availability */
      const filteredStoresByAmount = stores?.filter((el) => el.amount > 0);

      /** secondly let filter by ajax updated current city id */
      let filteredStores = filteredStoresByAmount?.filter(
        (el) => el.cityId == getters['stores/getCurrentCityId']
      );

      /**
       * if there are no matches for the current city, need to select warehouses for the default city ( According Technical Task )
       */
      if (filteredStores?.length == 0) {
        filteredStores = filteredStoresByAmount?.filter((el) => el.cityId == defaultCityId);
      }

      /** thirdly let filter by first found store city */
      if (filteredStores?.length == 0) {
        filteredStores = filteredStoresByAmount?.filter(
          (el) => el.cityId == filteredStoresByAmount[0].cityId
        );
        // dispatch('stores/setActiveCityName', filteredStores[0].cityName);
      }

      return filteredStores;
    },
    'stores/getCities': ({ data: { cities } }, getters) =>
      cities?.map((el) => ({
        ...el,
        active: el.UF_NAME == getters['stores/getActiveCityName'],
      })) || [],
  },
};
